import React from "react";
// import { useSelector } from "react-redux";

import { Route, Redirect } from "react-router-dom";
import { clearUser } from "../store/userSlice";
import { useDispatch } from "react-redux";

export function PrivateRoute({ component: Component, ...rest }) {
  // const user = useSelector((state) => state.user.data);
  const dispatch = useDispatch();

  // const checkMenuPermission = (_menu, _path) => {
  //   console.log(_menu, _path);
  //   if (_menu !== null) {
  //     var visible = false;
  //     _menu.forEach((item) => {
  //       if (item.pers?.includes(_path)) visible = true;
  //       if (item.submenu !== null)
  //         item.submenu.forEach((subItem) => {
  //           if (subItem.pers?.includes(_path)) visible = true;
  //         });
  //     });
  //     return visible;
  //   } else return false;
  // };

  if (localStorage.getItem("token") !== null) {
    /** Presss F5 then user = null  */
    // if (rest.path === "/" || rest.path === "/err404") return <Route {...rest} component={Component} />;
    // else {
    //   var menu = user
    //     ? JSON.parse(user.menu).filter((item) => {
    //         return item !== null;
    //       })
    //     : null;
    //   if (checkMenuPermission(menu, rest.location.pathname.split("/")[1]) === true) return <Route {...rest} component={Component} />;
    //   // else return <Redirect to="/err404" />;
    //   else return <Route {...rest} component={Component} />;
    // }
    return <Route {...rest} component={Component} />;
  } else {
    dispatch(clearUser());
    return <Redirect to="/login" />;
  }
}
